import type * as React from "react";
import { cn } from "cn";
import { ToggleGroup, ToggleGroupItem } from "./ui/toggle-group";

export type SegmentOption = string | { label: React.ReactNode; value: string };

/**
 * 2–4 mutually exclusive options. The selected segment lifts to a white chip; the
 * rest stay quiet. Distinct from Tabs (underline nav).
 */
export interface SegmentedControlProps {
  options: SegmentOption[];
  value?: string;
  onChange?: (value: string) => void;
  /** @default "md" */
  size?: "sm" | "md";
  /** Stretch segments to fill width. @default true */
  fullWidth?: boolean;
  style?: React.CSSProperties;
}


export function SegmentedControl({options, value, onChange, size = "md", fullWidth = true, style}: SegmentedControlProps) {
  return <ToggleGroup type="single" value={value ?? ""} onValueChange={next => { if (next !== "") onChange?.(next); }}
    spacing={1} style={style} className={cn("rounded-lg border border-solid border-[var(--border-subtle)] bg-secondary p-1", fullWidth && "w-full")}>
    {options.map(option => {
      const item = typeof option === "string" ? {value: option, label: option} : option;
      return <ToggleGroupItem key={item.value} value={item.value} className={cn(
        "rounded-md border-0 bg-transparent px-3.5 text-[length:var(--text-body-sm)] font-bold text-muted-foreground data-[state=on]:bg-card data-[state=on]:text-foreground data-[state=on]:shadow-xs",
        size === "sm" ? "h-8" : "h-10", fullWidth && "flex-1"
      )}>{item.label}</ToggleGroupItem>;
    })}
  </ToggleGroup>;
}
